import axios from 'axios';

export const listTickets = async ({ eventId }) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/ticket`
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const createTicket = async ({ headers, payload, eventId, sectionId }) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section/${sectionId}/ticket`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const updateTicket = async ({ headers, payload, eventId, sectionId, ticketId }) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section/${sectionId}/ticket/${ticketId}`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const updateTicketMany = async ({ headers, payload }) => {
  const eventId = payload.event?._id;
  const sectionId = payload.section?._id;

  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section/${sectionId}/ticket/update/many`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const deleteTicket = async ({ headers, eventId, sectionId, ticketId }) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section/${sectionId}/ticket/${ticketId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const createBatch = async ({ headers, payload, eventId, sectionId, ticketId }) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section/${sectionId}/ticket/${ticketId}/batch`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const updateBatch = async ({ headers, payload, eventId, sectionId, ticketId, batchId }) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section/${sectionId}/ticket/${ticketId}/batch/${batchId}`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const deleteBatch = async ({ headers, eventId, sectionId, ticketId, batchId }) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section/${sectionId}/ticket/${ticketId}/batch/${batchId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const createVoucher = async ({ headers, payload, eventId, sectionId, ticketId }) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section/${sectionId}/ticket/${ticketId}/voucher`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const updateVoucher = async ({
  headers,
  payload,
  eventId,
  sectionId,
  ticketId,
  voucherId
}) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section/${sectionId}/ticket/${ticketId}/voucher/${voucherId}`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const deleteVoucher = async ({ headers, eventId, sectionId, ticketId, voucherId }) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_EVENT_BASE_URL}/${eventId}/section/${sectionId}/ticket/${ticketId}/voucher/${voucherId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};
